var map = {
	"./icons/arrow-down.svg": 4746,
	"./icons/email-icon.svg": 8692,
	"./icons/fb-icon.svg": 4323,
	"./icons/ln-icon.svg": 4766,
	"./icons/logo-2.svg": 9733,
	"./icons/logo.svg": 3190,
	"./icons/phone-icon.svg": 9910,
	"./icons/service-crypto.svg": 1886,
	"./icons/service-gambling.svg": 5674,
	"./icons/service-market.svg": 2847,
	"./icons/service-med.svg": 6115,
	"./icons/service-parking.svg": 9603,
	"./icons/service-terminal.svg": 2621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 564;